// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#aw--c #aw-sl #aw-fw>h3{font-size:var(--font-size-18)!important;margin-bottom:10px!important;font-family:var(--font-family)!important;font-weight:500!important;line-height:1.1!important;color:var(--font-color)!important;padding:.83em 0!important;text-align:center!important}#aw--c #aw-sl #aw-fw{margin-top:20px!important}", ""]);
// Exports
module.exports = exports;
